import styled from 'styled-components';
const FooterMenu = styled.div`
display:block;
width:100%;
background:${props => props.theme.colors.footer};
position:absolute;
bottom:0;
padding: 50px 0px 50px 0px;
`
const LogoWrapper = styled.div`
display: flex;
flex-direction: row;
flex-wrap: nowrap;
justify-content: space-evenly;
width:200px
align-items: center;

`

const Logo = styled.img`
height:50px;
`
const Credit = styled.div`
position:absolute;
color:${props => props.theme.colors.contraste};
bottom:5px;
right:5px;
`

const  Footer= () => {
    const anneeCourante = new Date().getFullYear()
    return (
    <FooterMenu>
        <LogoWrapper>
            <Logo src="/img/Logo_HISoMA_Blanc.png" />
            <Logo src="/img/Logo_CNRS_Blanc.png" />
            <Logo src="/img/Logo_Lyon2_Blanc.png" />
            <Logo src="/img/Logo_UDL_blanc.png" />
            <Logo src="/img/Logo_Ifpo_blanc.png" />
            <Logo src="/img/Logo_Huma-Num-pro_Blanc.png" />
        </LogoWrapper>
        <Credit>©IGLS Data {anneeCourante}</Credit>

    </FooterMenu>
    );
}

export default Footer;